import './bootstrap';
import Alpine from 'alpinejs';
import * as Sentry from "@sentry/browser";
import HorseInsuranceData from './data/HorseInsuranceData';
import BankIDData from './data/BankIDData';
import ScrollTo from './scrollto-helper';
import SaddleInsuranceData from './data/SaddleInsuranceData';
import DogInsuranceData from './data/DogInsuranceData';
import InsurelyData from './data/InsurelyData';
import SharedPaymentData from './data/SharedPaymentData';
import CatInsuranceData from './data/CatInsuranceData';

if (['dunstan-app.convertor.nu', 'forsakra.dunstan.se'].includes(window.location.host)) {
  Sentry.init({
    dsn: "https://910d9726b7fdfa92807b92370521b978@o4507940421959680.ingest.de.sentry.io/4507940508139600",
    integrations: [
      Sentry.browserTracingIntegration(),
    ],

    attachStacktrace: true,
    maxBreadcrumbs: 300,

    tracesSampler: (ctx) => {
      const url = ctx?.name || "";
      if (url.includes("/checkout") || url.includes("/api/critical")) return 1.0;
      return 0.1;
    },

    tracePropagationTargets: [
      'https://forsakra.dunstan.se',
      'https://dunstan-app.convertor.nu'
    ],

    environment: window.location.host === 'forsakra.dunstan.se' ? 'production' : 'staging',

    sendDefaultPii: false
  });
}

window.Alpine = Alpine;

window.scrollto = new ScrollTo({ duration: 750 });

document.addEventListener('alpine:init', () => {
  Alpine.data('HorseInsuranceData', HorseInsuranceData);

  Alpine.data('SaddleInsuranceData', SaddleInsuranceData);

  Alpine.data('CatInsuranceData', CatInsuranceData);
  
  Alpine.data('DogInsuranceData', DogInsuranceData);

  Alpine.data('SharedPaymentData', SharedPaymentData);

  Alpine.data('BankIDData', BankIDData);

  Alpine.data('InsurelyData', InsurelyData);
});

Alpine.start();

import.meta.glob([
    '../img/**',
    '../images/**',
    '../fonts/**',
]);

window.currencyFormat = function (number) {
  number = parseInt(String(number).replace(/[^0-9]+/g, ''));

  return new Intl.NumberFormat("sv-SE").format(number)
}

window.insurelyInsuranceCompanyName = function (name) {
  let mapping = {
    'se-agria': "Agria",
    'se-bliwa': "Bliwa",
    'se-dina': "Dina",
    'se-euroaccident': "Euroaccident",
    'se-folksam': "Folksam",
    'se-gjensidige': "Gjensidige",
    'se-hedvig': "Hedvig",
    'se-ica': "ICA",
    'se-if': "If",
    'se-lansforsakringar': "Länsförsäkringar",
    'se-lassie': "Lassie",
    'se-moderna': "Moderna",
    'se-movestic': "Movestic",
    'se-paydrive': "Paydrive",
    'se-sensor': "Sensor",
    'se-skandia': "Skandia",
    'se-soderberg-partners': "Söderberg & Partners",
    'se-svedea': "Svedea",
    'se-sveland': "Sveland",
    'se-trekronor': "Trekronor",
    'se-trygg-hansa': "Trygg-Hansa",
    'se-volvia': "Volvia",
    'se-demo': "Demo"
  };

  return mapping[name] || name;
}